function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SurveyDisclaimer from './survey-components/disclaimer';
import IACSurveyModal from './survey-components/survey_modal';
import { hexToRgb, rgb_is_light, standardize_color } from './utils';
var IconWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n"])));
var OpenSurveyButton = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 250px;\n  display: flex;\n  align-items: center;\n  right: 0px;\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  transition: transform 250ms;\n  transform: translateX(calc(100% - 36px));\n  cursor: pointer;\n  ", "\n  :hover {\n    transform: none;\n  }\n\n  ", "\n\n  @media (max-width: 800px) {\n    position: fixed;\n    bottom: 50%;\n    z-index: 200;\n    top: unset;\n  }\n\n  @media (min-width: 800px) {\n    ", "\n  }\n\n"])), function (props) {
  return props.color || "#008a16";
}, function (props) {
  return props.textColor || 'white';
}, function (props) {
  return props.forceShowing && "transform: none;";
}, function (props) {
  return props.fullScreenEnabled && "\n    position: fixed;\n    bottom: 50%;\n    z-index: 200;\n    top: unset;\n  ";
}, function (props) {
  return props.showDisclaimer && "\n      z-index: 376;\n      transform: none;\n  ";
});
var ButtonElements = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 5px 10px 5px 5px;\n\n  @media (min-width: 800px) {\n    ", "\n  }\n"])), function (props) {
  return props.showDisclaimer ? "pointer-events: none;" : "";
});
var OpenSurveyLabel = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var DisclaimerWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 375;\n  top: 0px;right: 0px;bottom:0px;left:0px;\n  background-color: rgba(51,51,51, 0.5);\n  @media (max-width: 800px) {\n    display: none;\n  }\n"])));
var eventForceShowingSurvey = 'iac-force-showing-survey';
var IACSurvey = /*#__PURE__*/function (_React$Component) {
  _inherits(IACSurvey, _React$Component);
  var _super = _createSuper(IACSurvey);
  function IACSurvey(props) {
    var _this;
    _classCallCheck(this, IACSurvey);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleForceShowing", function () {
      setTimeout(function () {
        if (_this._isMounted) {
          _this.setState({
            forceShowing: true
          });
          setTimeout(function () {
            if (_this._isMounted) {
              _this.setState({
                forceShowing: false
              });
            }
          }, 3000);
        }
      }, 3000);
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      window.addEventListener(eventForceShowingSurvey, _this.handleForceShowing);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
      window.removeEventListener(eventForceShowingSurvey, _this.handleForceShowing);
    });
    _defineProperty(_assertThisInitialized(_this), "openSurvey", function () {
      _this.setState({
        isOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "markCampaignId", function () {
      try {
        localStorage.setItem("iac-campaign-".concat(_this.props.campaignId), true);
      } catch (e) {}
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !_this.state.isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OpenSurveyButton, {
        showDisclaimer: _this.state.showDisclaimer,
        forceShowing: _this.state.forceShowing,
        fullScreenEnabled: _this.props.fullScreenEnabled,
        color: _this.props.color,
        textColor: _this.state.textColor
      }, _this.state.showDisclaimer && /*#__PURE__*/React.createElement(SurveyDisclaimer, {
        color: _this.props.color,
        textColor: _this.state.textColor,
        getLabel: _this.props.getLabel,
        onOpen: function onOpen() {
          _this.openSurvey();
          _this.setState({
            showDisclaimer: false
          });
          _this.markCampaignId();
        },
        onDismiss: function onDismiss() {
          _this.setState({
            showDisclaimer: false
          });
          _this.markCampaignId();
        }
      }), /*#__PURE__*/React.createElement(ButtonElements, {
        showDisclaimer: _this.state.showDisclaimer,
        onClick: function onClick() {
          if (_this.props.onOpen) {
            _this.props.onOpen();
          }
          _this.openSurvey();
        }
      }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M502.9,128.9H478c-11.8,0-21.3,9.6-21.3,21.3v112.6c0,61.3-24.2,110.9-71.8,147.6c-9.3,7.2-11.1,20.6-3.9,29.9   c7.2,9.3,20.6,11.1,29.9,3.9c40.4-31,88.5-87.7,88.5-181.4v-91.3h3.6c19,0,36.9,7.4,50.4,20.9c13.5,13.5,20.9,31.4,20.9,50.4v160.3   c0,11.8,9.6,21.3,21.3,21.3h218.7c20.6,0,37.4,16.8,37.4,37.4s-16.8,37.4-37.4,37.4h-67.2c-11.8,0-21.3,9.6-21.3,21.3   s9.6,21.3,21.3,21.3h67.2c20.6,0,37.4,16.8,37.4,37.4S834.9,617,814.3,617H747c-11.8,0-21.3,9.6-21.3,21.3s9.6,21.3,21.3,21.3h49.8   c20.6,0,37.4,16.8,37.4,37.4s-16.8,37.4-37.4,37.4h-51.5c-11.8,0-21.3,9.6-21.3,21.3s9.6,21.3,21.3,21.3   c20.6,0,37.4,16.8,37.4,37.4s-16.8,37.4-37.4,37.4H400.3c-33.6,0-57.1-23.9-57.1-58.1c0-11.8-9.6-21.3-21.3-21.3   s-21.3,9.6-21.3,21.3v6.8c0,12.5-5.9,25.4-16.3,35.6c-10.1,9.9-23.2,15.8-35,15.8h-76.3V488.2h73c30.1,0,54.6,24.5,54.6,54.6v111.9   c0,11.8,9.6,21.3,21.3,21.3s21.3-9.6,21.3-21.3V542.8c0-53.7-43.7-97.3-97.3-97.3h-94.3c-11.8,0-21.3,9.6-21.3,21.3v406.6   c0,11.8,9.6,21.3,21.3,21.3h97.7c28.2,0,55-14.7,72.7-36.6c2.4,3,5,5.9,7.7,8.6c18.3,18,43.4,28,70.7,28h345.1   c44.2,0,80.1-35.9,80.1-80.1c0-14.4-3.8-27.9-10.4-39.5c35.4-8.3,61.9-40.1,61.9-78c0-19.3-6.9-37.1-18.3-50.9   c21.5-14.4,35.7-38.9,35.7-66.7c0-23.2-9.9-44.1-25.7-58.8c15.8-14.6,25.7-35.6,25.7-58.8c0-44.2-35.9-80.1-80.1-80.1H616.9v-139   C616.9,180,565.7,128.9,502.9,128.9z"
      })))), /*#__PURE__*/React.createElement(OpenSurveyLabel, null, _this.props.getLabel('embedded_survey.feedback')))), _this.state.showDisclaimer && /*#__PURE__*/React.createElement(DisclaimerWrapper, null)), _this.state.isOpen && /*#__PURE__*/React.createElement(IACSurveyModal, {
        surveyData: _this.props.surveyData,
        preselectionnedAnswers: _this.props.preselectionnedAnswers,
        getLabel: _this.props.getLabel,
        color: _this.props.color,
        appTitle: _this.props.appTitle,
        onSubmit: _this.props.onSubmit,
        closeSurvey: function closeSurvey() {
          _this.setState({
            isOpen: false
          });
        }
      }));
    });
    var standardizedColor = standardize_color(props.color || '#008a16');
    var rgbColor = hexToRgb(standardizedColor);
    var colorWithFilter = [Math.max(rgbColor[0] - 30, 0), Math.max(rgbColor[1] - 30, 0), Math.max(rgbColor[2] - 30, 0)];
    _this.state = {
      isOpen: false,
      forceShowing: false,
      textColor: rgb_is_light(hexToRgb(standardize_color(props.color || "#008a16"))) ? 'rgb(98,100,105)' : 'white',
      hoverColor: "rgb(".concat(colorWithFilter[0], ",").concat(colorWithFilter[1], ",").concat(colorWithFilter[2], ")"),
      showDisclaimer: props.showDisclaimer || false
    };
    _this._isMounted = false;
    return _this;
  }
  return _createClass(IACSurvey);
}(React.Component);
_defineProperty(IACSurvey, "propTypes", {
  appTitle: PropTypes.string.isRequired,
  // Title of the application
  surveyData: PropTypes.object,
  // The survey questions
  preselectionnedAnswers: PropTypes.object,
  // Preselectionned answer
  getLabel: PropTypes.func.isRequired,
  // Function to retrieve the label
  onOpen: PropTypes.func.isRequired,
  // Callback function when the user opens the survey
  onSubmit: PropTypes.func.isRequired,
  // Callback function when the user submits the data,
  color: PropTypes.string.isRequired,
  fullScreenEnabled: PropTypes.bool,
  showDisclaimer: PropTypes.bool,
  campaignId: PropTypes.string
});
export default IACSurvey;